import { render, staticRenderFns } from "./Profitability.vue?vue&type=template&id=124e70f9"
import script from "./Profitability.vue?vue&type=script&lang=js"
export * from "./Profitability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports